import { to } from 'await-to-js';
import { createI18n } from 'vue-i18n'
import { useJurisdictionSwitch } from "@dutypay/front-end-design-system/src/composables";
import { interceptor } from "@dutypay/front-end-design-system";
import "@dutypay/front-end-design-system/src/locales/numeralLocales";
import { cloneDeep } from "lodash";
import { loadInitialJurisdiction } from "./utils/jurisdiction";

const { setDocumentLanguage } = useJurisdictionSwitch();

const jurisdiction = await loadInitialJurisdiction();
setDocumentLanguage(jurisdiction);
const locale = jurisdiction.i18n;

async function remoteFetchTranslations() {
  let messages = {};
  let translationValues, error;
  [error, translationValues] = await to(
    interceptor.get(
      `${process.env.VUE_APP_API_DUTYPAY}/api/v0/translations/sso/${locale}`,
    ),
  );
  if (error) {
    messages[locale] = {};
  } else {
    messages[locale] = cloneDeep(translationValues.data);
    messages[locale] = {
      ...messages[locale],
    };
  }
  return messages;
}

export const i18n = createI18n({
  globalInjection: true,
  useScope: "global",
  legacy: false,
  locale: jurisdiction.i18n,
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en-US',
  messages: await remoteFetchTranslations(),
  fallbackWarn: false,
  silentTranslationWarn: true,
  silentFallbackWarn: true
});
